// TODO: see about using some nameof() package here. maybe?
export const counterTypes = {
  state: {
    selectedSponsor: 'selectedSponsor',
    selectedSite: 'selectedSite',
    featureFlags: 'featureFlags',
    sites: 'sites',
    sponsors: 'sponsors',
    programs: 'programs',
    siteAppDates: 'siteAppDates',
    siteAppNonCongregateMeals: 'siteAppNonCongregateMeals',
    pwaInstalled: 'pwaInstalled',
    isOnline: 'isOnline',
    isSyncing: 'isSyncing',
    selectedSponsorId: 'selectedSponsorId',
    selectedSiteId: 'selectedSiteId',
    selectedProgramId: 'selectedProgramId',
    selectedMealDate: 'selectedMealDate',
    timeStamp: 'timeStamp'
  },
  mutations: {
    updateFeatureFlags: 'updateFeatureFlags',
    updateSites: 'updateSites',
    updateSponsors: 'updateSponsors',
    updatePrograms: 'updatePrograms',
    updateSiteAppDates: 'updateSiteAppDates',
    updateSiteAppNonCongregateMeals: 'updateSiteAppNonCongregateMeals',
    updatePwaInstalled: 'updatePwaInstalled',
    updateIsOnline: 'updateIsOnline',
    updateIsSyncing: 'updateIsSyncing',
    updateSelectedSponsorId: 'updateSelectedSponsorId',
    updateSelectedSiteId: 'updateSelectedSiteId',
    updateSelectedProgramId: 'updateSelectedProgramId',
    updateSelectedMealDate: 'updateSelectedMealDate',
    updateTimeStamp: 'updateTimeStamp'
  },
  actions: {
    setFeatureFlags: 'setFeatureFlags',
    setSites: 'setSites',
    setSponsors: 'setSponsors',
    setPrograms: 'setPrograms',
    setSiteAppDates: 'setSiteAppDates',
    setSiteAppNonCongregateMeals: 'setSiteAppNonCongregateMeals',
    setPwaInstalled: 'setPwaInstalled',
    setIsOnline: 'setIsOnline',
    setIsSyncing: 'setIsSyncing',
    setSelectedSponsorId: 'setSelectedSponsorId',
    setSelectedSiteId: 'setSelectedSiteId',
    setSelectedProgramId: 'setSelectedProgramId',
    setSelectedMealDate: 'setSelectedMealDate',
    setTimeStamp: 'setTimeStamp'
  }
};
